import { PanelLeft } from "lucide-react";
import { useSidebar } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";

/**
 * Collapse/expand handle rendered as a small tab attached to the
 * outer edge of the left navigation.
 */
export const SidebarTab = () => {
  const { toggleSidebar, open } = useSidebar();

  return (
    <button
      type="button"
      onClick={toggleSidebar}
      aria-label="Toggle navigation"
      className={cn(
        "hidden md:flex sticky top-20 z-30 -ml-px h-12 w-7 items-center justify-center self-start p-1.5",

        "rounded-r-md border border-l-0 border-sidebar-border bg-sidebar text-sidebar-foreground/70",
        "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground transition-colors shadow-sm",
      )}
    >
      <PanelLeft
        className={cn("h-3.5 w-3.5 transition-transform", !open && "rotate-180")}
      />
    </button>
  );
};
